export default __webpack_public_path__ + "9a4ee77.png";